import FetchStatusRepository from "../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository      from "../../../domain/fundamentals/message/notify/NotifyRepository";
import Pagination            from "../../../domain/fundamentals/pagination/Pagination";
import PlanRepository        from "../../../domain/plan/PlanRepository";
import Plans                 from "../../../domain/plan/Plans";
import FetchStatusDataSource from "../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import NotifyDataSource      from "../../../infrastructure/datasource/notify/NotifyDataSource";
import PlanDataSource        from "../../../infrastructure/datasource/plan/PlanDataSource";

class GetPlans {
  constructor(
    private readonly dispatch,
    private readonly planRepository: PlanRepository = new PlanDataSource(),
    private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(dispatch),
    private readonly notifyRepository: NotifyRepository = new NotifyDataSource(dispatch),
  ) {
  }

  public async execute(pagination: Pagination): Promise<{plans: Plans, pagination: Pagination}> {
    try {
      this.fetchStatusRepository.start();
      return await this.planRepository.findByPage(pagination);
    } catch (e) {
      this.notifyRepository.fetchFailure();
      return {
        plans: new Plans(),
        pagination: pagination,
      };
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default GetPlans;
